import { UserProfile, UserProfileType } from 'Types';

// Google

export function gapi() {
  return window.gapi ?? null;
}

export function gapiAuth() {
  return gapi()?.auth2 ?? null;
}

export function gapiAuthInstance() {
  return gapiAuth()?.getAuthInstance();
}

function getIsGoogleSignedIn(): boolean {
  return gapiAuthInstance()?.isSignedIn.get() ?? false;
}

export function getGoogleProfile(): UserProfile | null {
  if (getIsGoogleSignedIn() === false) {
    return null;
  }

  const profile =
    gapiAuthInstance()?.currentUser.get().getBasicProfile() ?? null;
  const authResponse = gapiAuthInstance()?.currentUser.get().getAuthResponse();

  if (profile == null || authResponse == null) {
    return null;
  }

  return {
    type: UserProfileType.GOOGLE,
    id: profile.getId(),
    name: profile.getEmail(),
    image: profile.getImageUrl(),
    accessToken: authResponse.id_token,
  };
}

export function signOutGoogle() {
  if (getIsGoogleSignedIn()) {
    gapiAuthInstance()?.signOut();
  }
}

// Facebook

export function fb() {
  return window.FB ?? null;
}

export function getFacebookProfile(): Promise<UserProfile | null> {
  return new Promise((resolve) => {
    fb()?.getLoginStatus((response: fb.StatusResponse) => {
      if (response.status === 'connected' && response.authResponse.accessToken) {
        resolve({
          type: UserProfileType.FACEBOOK,
          id: response.authResponse.userID,
          accessToken: response.authResponse.accessToken,
          name: '',
          image: '',
        });
      }

      resolve(null);
    });

    resolve(null);
  });
}

export function signOutFacebook() {
  fb()?.getLoginStatus((response: fb.StatusResponse) => {
    if (response.status === 'connected') {
      fb().logout();
    }
  });
}
